import { AVAILABLE_PRESCRIPTION_TYPES } from 'shared/consts/productTemplates'

export const getFreeDeliveryTypes = ({ isFreeDelivery }) =>
  AVAILABLE_PRESCRIPTION_TYPES.ALL.reduce(
    (acc, prescriptionType) => {
      if (isFreeDelivery(prescriptionType)) {
        acc.freeDeliveryTypes.push(prescriptionType)
      } else {
        acc.payedDeliveryTypes.push(prescriptionType)
      }
      return acc
    },
    { freeDeliveryTypes: [], payedDeliveryTypes: [] }
  )
